import { render, staticRenderFns } from "./AuthAdmin.vue?vue&type=template&id=0b9f459e&scoped=true&"
import script from "./AuthAdmin.vue?vue&type=script&lang=js&"
export * from "./AuthAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AuthAdmin.vue?vue&type=style&index=0&id=0b9f459e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f459e",
  null
  
)

export default component.exports